module.exports = __webpack_public_path__ + "static/media/Trinidad Dr, Tiburon, CA8.7e3fb1d6.jpg";